import {createDraftSafeSelector} from '@reduxjs/toolkit';

import consentFlags from '../../consts/consents/consentFlags';
import {selectConsentsFlagsValues} from './session';

const selectAiAssistantSlice = (state) => state.aiAssistant;

const selectIsAiAssistantWidgetOpened = createDraftSafeSelector(
    selectAiAssistantSlice,
    (state) => state.isWidgetOpened
);

const selectAiAssistantState = createDraftSafeSelector(selectAiAssistantSlice, (state) => state.assistantState);

const selectAiAssistantProposal = createDraftSafeSelector(selectAiAssistantSlice, (state) => state.proposal);

const selectIsAiAssistantConsentAccepted = createDraftSafeSelector(
    selectConsentsFlagsValues,
    (consentsFlagsValues) => !!consentsFlagsValues[consentFlags.AI_ASSISTANT]
);

export {
    selectAiAssistantProposal,
    selectAiAssistantState,
    selectIsAiAssistantConsentAccepted,
    selectIsAiAssistantWidgetOpened,
};
